const ExpUtils = require('./ExpUtils');

module.exports = class ExperimentationServer {
  /**
    * Get serverside recipesIds from EFCKEY query param or request header
    * @param {object} req
    * @returns
    */
  static getServersideRecipeIdsFromRequest(req) {
    const url = req.originalUrl;
    let parsedObject = {};
    const search = url.substr(url.indexOf('?'));
    const requestParams = ExpUtils.queryString(search);
    if (typeof requestParams.EFCKEY !== 'undefined') {
      try {
        parsedObject = JSON.parse(decodeURIComponent(requestParams.EFCKEY));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed getting EFCKEY: ', e);
      }
    }

    if (typeof req.headers !== 'undefined' && typeof req.headers['x-macys-experiments'] !== 'undefined') {
      try {
        parsedObject = JSON.parse(decodeURIComponent(req.headers['x-macys-experiments']));
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed getting X-Macys-Experiments: ', e);
      }
    }

    if (Array.isArray(parsedObject.EXPERIMENT)) {
      return parsedObject.EXPERIMENT;
    }

    return [];
  }
};
